import { useState } from 'react';
import { useParams } from 'react-router';
import Child from './Child';
import Adult from './Adult';
import BaseLayout from '../../commons/BaseLayout';

export default function SignsAndSymptoms() {
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const { id } = useParams();
  const [activeVersion, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');
  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar fitHeight>
      {activeVersion === 'Child' ? <Child signAndSymptomsId={id} /> : <Adult signAndSymptomsId={id} />}
    </BaseLayout>
  );
}
